import React from 'react';

import { Section } from '@gogame/components';
import { FormField, withForm, DialogV2, SidePageV2 } from '@gogame/form';
import { useQuery } from '@gogame/query';

import { loadLookalikes } from 'scenes/CustomAudiences/LookalikeAudiences/sources/fields';
import { loadUnusedAccountsLookalikeAudience } from 'scenes/CustomAudiences/LookalikeAudiences/sources/sharedAccounts';

import { LOOKALIKE_AUDIENCE, SHARE_ACCOUNTS } from './constants';
import { validationSchema } from './schemas';

export default withForm({ validationSchema: validationSchema })(
  ({ loading, onClose, onExited, open, values }) => {
    const lookalikeId = values[LOOKALIKE_AUDIENCE];
    const { data: loadLookalikeName, isLoading } = useQuery(
      ['lookalikes'],
      loadLookalikes,
      {
        select: (lookalikes) =>
          lookalikes.find((lookalike) => lookalike.id === lookalikeId)?.name,
      }
    );

    return (
      <SidePageV2
        open={open}
        onExited={onExited}
        onClose={onClose}
        disableEscapeKeyDown={true}
        fullWidth={true}
        loading={loading}
        fetching={isLoading}
      >
        <SidePageV2.Title
          title={'Share Lookalike Audience'}
          subTitle={loadLookalikeName}
          entityId={values[LOOKALIKE_AUDIENCE]}
        />
        <SidePageV2.NewBody scroll={false}>
          <Section title={'Share to Accounts'}>
            <FormField.MultiSelect
              placeholder={'Select accounts'}
              source={loadUnusedAccountsLookalikeAudience}
              depends={[LOOKALIKE_AUDIENCE]}
              name={SHARE_ACCOUNTS}
              padding={0}
            />
          </Section>
        </SidePageV2.NewBody>
        <DialogV2.Actions>
          <DialogV2.CloseButton />
          <DialogV2.SubmitButton />
        </DialogV2.Actions>
      </SidePageV2>
    );
  }
);
